export default {
  'components.DatePicker.clear': 'Clear',
  'components.DatePicker.cancel': 'Cancel',
  'components.DatePicker.choose': 'Please choose a date',
  'components.DatePicker.confirm': 'Confirm',
  'components.Dialog.no': 'No',
  'components.LoginFailed.title': 'Login Failed',
  'components.LoginFailed.notice': 'Please close and reopen this page',
  'components.Maintenance.title': 'System Maintenance',
  'components.Maintenance.notice': 'You can try refreshing the page later',
  'components.Maintenance.refresh': 'Refresh',
  'components.MenuTabBar.ticket': 'Tickets',
  'components.MenuTabBar.my': 'My Account',
  'components.MenuTabBar.menu_item.more': 'More',
  'components.MenuTabBar.menu_item.home': 'Home',
  'components.MenuTabBar.menu_item.member_card': 'Member Card',
  'components.MenuTabBar.menu_item.coupon': 'Coupons',
  'components.MenuTabBar.menu_item.store': 'Store',
  'components.MenuTabBar.menu_item.store_value_card': 'Stored Value Card',
  'components.MenuTabBar.menu_item.loyalty_card': 'Loyalty Card',
  'components.MenuTabBar.menu_item.member_area': 'Member Area',
  'components.MenuTabBar.external_open_failed': 'Unable to open this link. Please try again later.',
  'components.NotFound.title': 'Business Information Not Found',
  'components.NotFound.notice': 'You can click the button below to try searching again',
  'components.OpenInLINE.browser_invalid': 'Cannot use Echoss VIP through this browser',
  'components.OpenInLINE.guide.title': 'Please follow the steps below:',
  'components.OpenInLINE.guide.step.one': '1. Open "Settings" in the LINE app',
  'components.OpenInLINE.guide.step.two': '2. Go to "LINE Labs"',
  'components.OpenInLINE.guide.step.three': '3. Turn off "Open links with default browser"',
  'components.OpenInLINE.guide.finish':
    'After completing the steps, click the link again to use it',
  'components.OpenInLINE.qr.title': 'LINE app exclusive feature',
  'components.OpenInLINE.qr.scan': 'Please scan the QR code with LINE to view this content.',
  'components.OpenInLINE.qr.brand_message':
    'No installation, no login required! Use "{brandName}" directly on LINE!',
  'components.OTPPhone.ManualOTPDialog.enter_verification_code':
    'Please enter the four-digit verification code provided by the store',
  'components.OTPPhone.verification_fail': 'Verification Failed',
  'components.OTPPhone.resend_seconds': 'Resend in {seconds} seconds',
  'components.OTPPhone.send_verification_code': 'Send Verification Code',
  'components.OTPPhone.auth_code.required': 'Please enter the verification code',
  'components.OTPPhone.message_unreceived': 'Did not receive the SMS?',
  'components.OTPPhone.message_auth_code': 'SMS Verification Code',
  'components.OTPPhone.verified': 'Verified',
} as Record<string, string>;
